import { AppRoutes } from "../../../../Core/App/AppRoutes";
import { LoginViewModel, LoginViewState } from "../../../../Core/ViewModels/Auth/LoginViewModel";
import { useLifecycle } from "../../../Hooks/Lifecycle/useLifecycle";
import { ViewModelLocator } from "../../../../Core/ViewModels/ViewModelLocator";
import { usePreventDefault } from "../../../Hooks/Form/usePreventDefault";
import { useInputTextFieldProps } from "../../../Hooks/Form/useInputProps";
import { useRedirectIfAuthenticated } from "../../../Hooks/Authentification/useRedirectIfAuthenticated";

export const useLoginPageController = () => {
    const { vm, state } = useLifecycle<LoginViewState, LoginViewModel>({
        getRef: () => ViewModelLocator.LoginVM,
        setRefValue: (value) => (ViewModelLocator.LoginVM = value),
        newInstance: () => new LoginViewModel(),
        logName: "LoginVM",
    });
    const onSubmit = usePreventDefault(vm.onSubmit);
    const registerField = useInputTextFieldProps(state, vm.onChangeField, { hideLabel: true, i18nPrefix: "LoginPage" });
    useRedirectIfAuthenticated(AppRoutes.WORKER_LIST);

    return { vm, state, onSubmit, registerField };
}